import { useState, useEffect } from 'react'
import { X } from 'lucide-react'

interface RejectNoteModalProps {
  open: boolean
  onClose: () => void
  onConfirm: (note: string) => void
  isPending: boolean
}

export default function RejectNoteModal({
  open,
  onClose,
  onConfirm,
  isPending,
}: RejectNoteModalProps) {
  const [note, setNote] = useState('')

  useEffect(() => {
    if (open) setNote('')
  }, [open])

  if (!open) return null

  function handleConfirm() {
    onConfirm(note.trim())
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative z-10 w-full max-w-sm rounded-xl border border-border bg-card shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-border">
          <h2 className="font-semibold text-sm">Tolak Transaksi</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4 space-y-3">
          <p className="text-sm text-muted-foreground">
            Transaksi ini akan ditolak. Tambahkan catatan untuk fan (opsional).
          </p>
          <div className="space-y-1">
            <label className="text-sm font-medium">Catatan Penolakan</label>
            <textarea
              rows={3}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Contoh: bukti pembayaran tidak jelas, nominal tidak sesuai..."
              className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:border-destructive focus:outline-none resize-none"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 px-5 pb-4">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-border px-4 py-2 text-sm hover:bg-accent"
          >
            Batal
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isPending}
            className="rounded-md bg-destructive px-4 py-2 text-sm font-medium text-white hover:bg-destructive/90 disabled:opacity-50"
          >
            {isPending ? 'Menolak...' : 'Tolak Transaksi'}
          </button>
        </div>
      </div>
    </div>
  )
}
